import useStoreSlug from 'src/common/hooks/useStoreSlug';
import { EventNamesMap, useAmplitude } from 'src/context/AmplitudeProvider';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import {
  TrackProductSearch,
  TrackCategoriesSliderClick,
  TrackHomepageCategoryFilter,
  TrackProductDetailClick,
  TrackBannerClick,
  TrackBannerImpression,
} from './types';

const useTrackHomepageEvents = () => {
  const { logEvent } = useAmplitude();
  const { user, isB2b } = useAuthContext();
  const { storeSlug } = useStoreSlug();

  const trackProductSearch: TrackProductSearch = ({ search, resultsCount }) => {
    if (user) {
      logEvent(EventNamesMap.ProductSearch, {
        email: user.email,
        is_b2b: !!isB2b,
        store_slug: storeSlug,
        results_count: resultsCount,
        search,
      });
    }
  };

  const trackCategoriesSliderClick: TrackCategoriesSliderClick = ({
    categorySlug,
  }) => {
    if (user) {
      logEvent(EventNamesMap.CategoriesSliderClick, {
        email: user.email,
        is_b2b: !!isB2b,
        category_slug: categorySlug,
        store_slug: storeSlug,
      });
    }
  };

  const trackBannerImpression: TrackBannerImpression = ({
    slug,
    name,
    order,
    url,
  }) => {
    logEvent(EventNamesMap.BannerImpression, {
      slug,
      name,
      order,
      url,
      email: user?.email,
      is_b2b: !!isB2b,
    });
  };

  const trackBannerClick: TrackBannerClick = ({ slug, name, order, url }) => {
    logEvent(EventNamesMap.BannerClick, {
      slug,
      name,
      order,
      url,
      email: user?.email,
      is_b2b: !!isB2b,
    });
  };

  const trackHomepageCategoryFilter: TrackHomepageCategoryFilter = ({
    categorySlug,
  }) => {
    if (user) {
      logEvent(EventNamesMap.HomepageCategoryFilter, {
        email: user.email,
        is_b2b: !!isB2b,
        category_slug: categorySlug,
        store_slug: storeSlug,
      });
    }
  };

  const trackProductDetailClick: TrackProductDetailClick = ({
    productName,
    productId,
    price,
    discountPrice,
  }) => {
    if (user) {
      logEvent(EventNamesMap.ProductDetailClick, {
        email: user.email,
        is_b2b: !!isB2b,
        product_name: productName,
        product_id: productId,
        discount_price: discountPrice,
        price,
      });
    }
  };

  return {
    trackProductSearch,
    trackCategoriesSliderClick,
    trackBannerClick,
    trackBannerImpression,
    trackHomepageCategoryFilter,
    trackProductDetailClick,
  };
};

export default useTrackHomepageEvents;
